import React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import {
  productionTimeColDefs,
  productionTimeColDefsWithEditButtons,
  transformProductionTimeData,
  transformProductionTimeDataEditable,
  isPayPeriodClosed
} from "components/Shared/TimeLogs/Definitions";
import * as yup from "yup";
import { MSpinner } from "components/Shared";
import MGrid, { ACTION_ADD, ACTION_DOWNLOAD } from "components/Shared/MGrid.tsx";
import MCard from "components/Shared/MCard.tsx";
import { DATA_TYPE_NUMBER, DATA_TYPE_DAYS_ELAPSED, DATA_TYPE_DATE } from "typeConstants/dataTypes";
class ProductionTimeCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editDialogBoxVisible: false,
      timeLogEdit: {},
      editedTimeMinutes: 0,
      deleteDialogBoxVisible: false,
      deleteRowId: 0,
      addDialogBoxVisible: false
    };
    this.getData = this.getData.bind(this);
    this.handleEditRow = this.handleEditRow.bind(this);
    this.handleEditConfirm = this.handleEditConfirm.bind(this);
    this.editDialogBox = this.editDialogBox.bind(this);
    this.deleteDialogBox = this.deleteDialogBox.bind(this);
    this.handleDeleteRow = this.handleDeleteRow.bind(this);
    this.handleDeleteConfirm = this.handleDeleteConfirm.bind(this);
    this.addDialogBox = this.addDialogBox.bind(this);
    this.handleDisableAdd = this.handleDisableAdd.bind(this);
    this.handleAddConfirm = this.handleAddConfirm.bind(this);
    this.setEditCardControls = this.setEditCardControls.bind(this);
    this.setAddCardControls = this.setAddCardControls.bind(this);

    this.editCardControlMethods = null;
    this.addCardControlMethods = null;

  }  
  componentDidUpdate(prevProps) {
    if (
      (!this.props.isUpdating && prevProps.isUpdating) ||
      (!this.props.isDeleting && prevProps.isDeleting) ||
      (!this.props.isAdding && prevProps.isAdding)) {
      this.props.getData(this.props.internetUserId, this.props.payPeriod.id);
      this.props.refreshSummaryCard?.();
    }
    if ((this.props.internetUserId !== prevProps.internetUserId) ||
      (this.props.payPeriod.id !== prevProps.payPeriod.id)
    ) {
      this.props.getData(this.props.internetUserId, this.props.payPeriod.id);
    }

    // to update mgrid the first time it receives data and all the subsequent times filterDate changes
    // Mgrid senses data has changed when its length changes, so its necessary to set data to [] and then bring in the new data.
    if (
      prevProps.data !== this.props.data ||
      prevProps.filterDate !== this.props.filterDate
    ) {
      this.setState({ data: [] }, () =>
        this.setState({
          data: this.getData(
            this.props.data,
            this.props.isEditable,
            this.props.filterDate
          )
        })
      );
    }
    if (!prevProps.data.length && this.props.data.length) {
      this.setState({
        data: this.getData(
          this.props.data,
          this.props.isEditable,
          this.props.filterDate
        )
      });
    }
  }
  UNSAFE_componentWillMount() {
    if ((!this.props.data || !this.props.data.length) && this.props.getData && !this.props.isFetchingData) {
      this.props.getData(this.props.internetUserId, this.props.payPeriod.id);
    }
  }
  setEditCardControls(cm) {
    this.editCardControlMethods = cm;
  }
  setAddCardControls(cm) {
    this.addCardControlMethods = cm;
  }
  handleEditRow(timeLog) {
    this.setState({
      editDialogBoxVisible: true,
      timeLogEdit: timeLog,
      editedTimeMinutes: timeLog.timeMinutes
    });
  }
  handleDeleteRow(id) {
    this.setState({
      deleteRowId: id,
      deleteDialogBoxVisible: true
    });
  }
  deleteDialogBox() {
    return (
      <Dialog
        open={this.state.deleteDialogBoxVisible}
        onClose={() => this.setState({ deleteDialogBoxVisible: false })}
        aria-labelledby="delete-dialog-title"
      >
        <DialogTitle id="delete-dialog-title">Are you sure you want to delete?</DialogTitle>
        <DialogActions>
          <Button onClick={() => this.setState({ deleteDialogBoxVisible: false })}>
            Cancel
          </Button>
          <Button onClick={this.handleDeleteConfirm}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
  handleDeleteConfirm() {
    this.props.delete(this.state.deleteRowId);
    this.setState({ deleteDialogBoxVisible: false });
  }
  editDialogBox() {
    return (
      <div className="production-time-dialog-box">
        <Dialog
          open={this.state.editDialogBoxVisible}
          onClose={() => {}}
          aria-labelledby="edit-production-time-dialog"
          PaperProps={{ style: { padding: 0, minWidth: "25em" } }}
        >
          <MCard
            title="Edit Production Time"
            getControlMethods={this.setEditCardControls}
            fields={[
              {
                key: "controlNumber",
                label: "Control #",
                value: this.state.timeLogEdit.controlIdNumber,
                editable: false,
                validation: yup.string().required("Control # is a required field")
              },
              {
                key: "minutes",
                label: "Minutes",
                value: this.state.editedTimeMinutes,
                dataType: DATA_TYPE_NUMBER,
                validation: yup.number().typeError("Must be a number").positive("Minutes must be positive").required("Minutes is required")
              },
              {
                key: "date",
                label: "Date",
                value: this.state.timeLogEdit.workDate,
                dataType: DATA_TYPE_DAYS_ELAPSED,
                editable: false,
                validation: yup.date().typeError("Must be a date").required("Date is a required field")

              }
            ]}
            startInEditMode={true}
            isEditable={true}
            onEditCancelled={() =>
              this.setState({ editDialogBoxVisible: false })
            }
            onEditFinished={(arr, obj) => this.handleEditConfirm(obj)}
          />
        </Dialog>
      </div >
    );
  }
  handleEditConfirm(obj) {
    let toUpdateDto = {
      caseTimeLogId: this.state.timeLogEdit.id,
      workDate: this.state.timeLogEdit.workDate,
      workTypeId: this.state.timeLogEdit.workTypeId,
      timeMinutes: obj.minutes
    };
    if (this.editCardControlMethods.runValidation(true)) {
      this.props.update(toUpdateDto, () => { });
      this.setState({ editDialogBoxVisible: false });
    }
  }
  getData(data, isEditable, filterDate) {
    let newData;
    if (isEditable) {
      newData = transformProductionTimeDataEditable(
        data,
        this.handleEditRow,
        this.handleDeleteRow,
        this.props.payPeriod
      );
    } else {
      newData = transformProductionTimeData(data);
    }
    if (filterDate) {
      let filterData = newData.filter(x => x.workDate === filterDate);
      return filterData;
    }
    return newData;
  }
  handleDisableAdd() {
    const { addControlNumber, addDate, addTimeMinutes } = this.state;
    if (!addControlNumber ||
      !addDate ||
      !addTimeMinutes ||
      isNaN(addControlNumber) ||
      addControlNumber < 0 ||
      isNaN(addTimeMinutes) ||
      addTimeMinutes < 0) {
      return true;
    }
    return false;
  }
  handleAddConfirm(obj) {
    let toAddDto = {
      controlIdNumber: obj.controlNumber,
      internetUserId: this.props.internetUserId,
      workDate: obj.date,
      workTypeId: this.props.workTypeId,
      timeMinutes: obj.minutes
    };
    if (this.addCardControlMethods.runValidation(true)) {
      this.props.add(toAddDto);
      this.setState({
        addDialogBoxVisible: false,
        addControlNumber: "",
        addTimeMinutes: "",
        addDate: ""
      });
    }
  }
  addDialogBox() {
    return (
      <div className="production-time-dialog-box">
        <Dialog
          open={this.state.addDialogBoxVisible}
          onClose={() => {}}
          aria-labelledby="add-production-time-dialog"
          PaperProps={{ style: { padding: 0 } }}
        >
          <MCard
            title="Add Production Time"
            getControlMethods={this.setAddCardControls}
            fields={[
              {
                key: "controlNumber",
                label: "Control #",
                validation: yup.string().required("Control # is a required field")
              },
              {
                key: "minutes",
                label: "Minutes",
                dataType: DATA_TYPE_NUMBER,
                validation: yup.number().typeError("Must be a number").positive("Minutes must be positive").required("Minutes is required")
              },
              {
                key: "date",
                label: "Date",
                dataType: DATA_TYPE_DATE,
                dataTypeOptions: {
                  nullable: false,
                  minDate: this.props.startDate,
                  maxDate: this.props.endDate
                },
                validation: yup.date().typeError("Must be a date").required("Date is a required field")
              }
            ]}
            startInEditMode={true}
            isEditable={true}
            onEditCancelled={() =>
              this.setState({ addDialogBoxVisible: false })
            }
            onEditFinished={(arr, obj) => this.handleAddConfirm(obj)}
          />
          {/* <TextField
            id="control-number"
            label="Control #"
            required
            onChange={value => {
              this.setState({ addControlNumber: value });
            }}
            error={
              isNaN(this.state.addControlNumber) ||
              this.state.addControlNumber < 0
            }
            errorText="Invalid Entry"
          />
          <TextField
            id="minutes"
            label="Minutes"
            required
            type="number"
            value={this.state.addTimeMinutes}
            onChange={value => this.setState({ addTimeMinutes: value })}
            error={
              isNaN(this.state.addTimeMinutes) || this.state.addTimeMinutes < 0
            }
            errorText="Invalid Entry"
          />
          <DatePicker
            id="date-datepicker"
            label="Date"
            required
            portal
            lastChild
            renderNode={null}
            disableScrollLocking
            onChange={(value, date) => {
              let dateLocal = moment(date);
              this.setState({ addDate: dateLocal });
            }}
            minDate={this.props.startDate}
            maxDate={this.props.endDate}
          /> */}
        </Dialog>
      </div>
    );
  }
  render() {
    if (this.props.isFetchingData) {
      return <MSpinner />;
    }
    return (
      <div>
        {this.props.isEditable ? this.editDialogBox() : []}
        {this.props.isEditable ? this.deleteDialogBox() : []}
        {this.props.isEditable ? this.addDialogBox() : []}
        <Card className={`card-unnested profile-card`}>
          <div
            className="grid-card card-style"
          >
            <MGrid
              columnDefinitions={
                this.props.isEditable
                  ? productionTimeColDefsWithEditButtons
                  : productionTimeColDefs
              }
              data={this.state.data}
              actions={
                this.props.isEditable && !isPayPeriodClosed(this.props.payPeriod)
                  ? [
                    {
                      code: ACTION_ADD,
                      onClick: () =>
                        this.setState({ addDialogBoxVisible: true })

                    },
                    {
                      code: ACTION_DOWNLOAD
                    }
                  ]
                  : undefined
              }
              isFetchingData={this.props.isFetchingData}
              displayNumOfItemsFound={false}
              headerText="Production Time Log"
            />
          </div>
        </Card>
      </div>
    );
  }
}
ProductionTimeCard.propTypes = {
  isEditable: PropTypes.bool,
  data: PropTypes.array.isRequired,
  isFetchingData: PropTypes.bool.isRequired,
  filterDate: PropTypes.string,
  update: PropTypes.func,
  getData: PropTypes.func,
  isUpdating: PropTypes.bool,
  isDeleting: PropTypes.bool,
  delete: PropTypes.func,
  add: PropTypes.func,
  internetUserId: PropTypes.number,
  isAdding: PropTypes.bool,
  payPeriod: PropTypes.object,
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  refreshSummaryCard: PropTypes.func,
  workTypeId: PropTypes.number,
};
export default ProductionTimeCard;
